const profile = {
    name: 'Nome',
    avatar: 'Avatar',
    givenName: 'Nome',
    familyName: 'Cognome',
    middleName: 'Secondo nome',
    fullName: 'Nome completo',
    nickname: 'Soprannome',
    preferredUsername: 'Nome utente preferito',
    profile: 'Profilo',
    website: 'Sito web',
    gender: 'Genere',
    birthdate: 'Data di nascita',
    zoneinfo: 'Fuso orario',
    locale: 'Lingua',
    address: {
        formatted: 'Indirizzo',
        streetAddress: 'Indirizzo',
        locality: 'Città',
        region: 'Stato/Provincia',
        postalCode: 'CAP',
        country: 'Paese',
    },
};
export default Object.freeze(profile);
